
// The RunDiffusion mark as a loader: its facets turn in one after another,
// hold while a light passes over them, and turn away in the same order. The
// board's loader (web/board/src/ui/MarkLoader.vue) is its twin, and both run
// on one clock (utils/rdMark.ts), so a board that opens behind the app's
// loader carries on the same turn.
import Vue from 'vue';
import { MARK_FACETS, MARK_MASK, MARK_VIEWBOX, facetStyle, joinMarkLoaderClock, leaveMarkLoaderClock } from '@/utils/rdMark';

export default Vue.extend({
	name: 'MarkLoader',
	props: {
		// the mark's width in px; its height follows
		size: { type: Number, default: 72 },
	},
	data () {
		return {
			// frozen: the facets never change, so Vue needn't watch them
			facets: Object.freeze(MARK_FACETS),
			viewBox: MARK_VIEWBOX,
			// how far into the shared turn this loader starts
			offset: joinMarkLoaderClock(),
		};
	},
	computed: {
		rootStyle (): Record<string, string> {
			return {
				'--ml-size': `${this.size}px`,
				'--ml-offset': `${this.offset}ms`,
				'--ml-mask': MARK_MASK,
			};
		},
	},
	beforeDestroy () {
		leaveMarkLoaderClock();
	},
	methods: {
		facetStyle,
	},
});
